import { ACTIONS as ACTIONS_DASHBOARD } from '../actions/dashboard'
import { ACTIONS as ACTIONS_FAVOURITE } from '../actions/favourite'

export const initialState = {
    appState: {
        postFavouriteError: null,
    },
    database: {
        favouriteResources: [],
    },
}

export default (state = initialState, action) => {
    const { database } = state

    switch (action.type) {
        case ACTIONS_DASHBOARD.GET_DASHBOARD.SUCCESS: {
            return {
                ...state,
                database: { ...database, favouriteResources: action.data?.userProfile?.favouriteResources || [] },
            }
        }

        case ACTIONS_FAVOURITE.POST_FAVOURITE.SUCCESS: {
            const newDatabase = { ...database }
            const resource = action.data.resourceId
            let favouritesArr = newDatabase.favouriteResources

            if (favouritesArr.includes(resource)) {
                favouritesArr = favouritesArr.filter(r => r !== resource)
            } else {
                favouritesArr = favouritesArr.concat([resource])
            }

            newDatabase.favouriteResources = favouritesArr

            return {
                ...state,
                database: newDatabase,
                appState: { ...state.appState, postFavouriteError: null },
            }
        }

        case ACTIONS_FAVOURITE.POST_FAVOURITE.FAILURE: {
            return {
                ...state,
                appState: { ...state.appState, postFavouriteError: action.error },
            }
        }

        default:
            return state
    }
}
